<div class="flex items-center justify-center dialog-header">
    {{type}} Course
    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>
</div>

<div class="dialog-content" style="margin-top: -15px;">
    <form [formGroup]="courseForm" (ngSubmit)="onSubmit()" class="mt-4">
        <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4 gap-4">

            <!-- Course Name (Full Width) -->
            <div class="md:col-span-2">
                <label class="block mb-2">Course Name<span class="text-red-500">*</span></label>
                <input pInputText formControlName="name" class="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && courseForm.get('name')?.errors }" />
                <small class="text-red-500" *ngIf="isSubmitted && courseForm.get('name')?.errors?.['required']">Course
                    name is required</small>
            </div>

            <!-- Course Code -->
            <div>
                <label class="block mb-2">Course Code<span class="text-red-500">*</span></label>
                <input pInputText formControlName="code" class="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && courseForm.get('code')?.errors }" />
                <small class="text-red-500" *ngIf="isSubmitted && courseForm.get('code')?.errors?.['required']">Course
                    code is required</small>
            </div>

            <!-- Duration -->
            <div>
                <label class="block mb-2">Duration (Months)<span class="text-red-500">*</span></label>
                <p-inputNumber formControlName="duration" [min]="1" [max]="120" class="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && courseForm.get('duration')?.errors }">
                </p-inputNumber>
                <small class="text-red-500"
                    *ngIf="isSubmitted && courseForm.get('duration')?.errors?.['required']">Duration is required</small>
            </div>



            <!-- Status (Full Width) -->
            <div>
                <label class="block mb-2">Status<span class="text-red-500">*</span></label>
                <p-select [options]="statusOptions" formControlName="status" placeholder="Select Status" appendTo="body"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && courseForm.get('status')?.errors }"
                    class="w-full">
                </p-select>
                <small class="text-red-500" *ngIf="isSubmitted && courseForm.get('status')?.errors?.['required']">Status
                    is required</small>
            </div>

            <!-- Department -->
            <div>
                <label class="block mb-2">Department<span class="text-red-500">*</span></label>
                <p-select [options]="allDepartments" formControlName="dept_id" placeholder="Select Department"
                    optionLabel="label" optionValue="value" filterBy="label" class="w-full"
                    [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && courseForm.get('dept_id')?.errors }">
                </p-select>
                <small class="text-red-500"
                    *ngIf="isSubmitted && courseForm.get('dept_id')?.errors?.['required']">Department is
                    required</small>
            </div>

            <!-- Description (Full Width) -->
            <div class="md:col-span-2">
                <label class="block mb-2">Description</label>
                <textarea pTextarea formControlName="description" class="w-full" rows="3"></textarea>
            </div>


        </div>

        <!-- Buttons -->
        <div class="flex justify-end gap-2 mt-4">
            <button pButton type="button" label="Cancel" class="p-button-outlined"
                (click)="handleCloseDialog()"></button>
            <button pButton type="submit" [label]="type" [loading]="btnLoading"></button>
        </div>
    </form>
</div>